<!--
================================================
Menu vertical de l'application
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <aside id="appMenu" class="menu" v-show="AppMenuCompIsOpened" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
    <ul class="menu-list">
      <!--      <li>-->
      <!--        <router-link v-bind:to="{ name: 'timeclock', params: {locale: $route.params.locale}}" id="appMenuLinkTimeclock" ><font-awesome-icon class="icon" :icon="['fas', 'stopwatch']" /> {{ $t("Pointeuse") }}</router-link>-->
      <!--      </li>-->

      <li>
        <router-link v-bind:to="{ name: 'timeTracking', params: {locale: $route.params.locale}}"
                     id="appMenuLinkTimeTracking">
          <font-awesome-icon class="icon" :icon="['fas', 'stopwatch']"/>
          {{ $t("Pointages") }}
          <!--          <span class="new">{{$t('nouveau!')}}</span>-->
        </router-link>
      </li>

      <!------------------------------------------>

      <li>
        <!-- NOTE : pour cette route j'ai forcé manuellement la class "router-link-exact-active" si le nom de la route est égal à "reports" car avec le paramètre "reportType", le lien #appMenuLinkReports doit être marqué comme actif pour la route "reports/detailed" et "reports/summary" -->
        <router-link
            v-bind:to="{ name: 'reports',
                query: {
                pjctArchShow:'active',
                cltArchShow: 'active'
                },
                params:{locale : $route.params.locale, organization: $route.params.organization,reportType:'summary',
                startDate: $moment().startOf('week').format('YYYY-MM-DD'),
                endDate: $moment().endOf('week').format('YYYY-MM-DD'),
            }}"
            id="appMenuLinkReports"
            v-bind:class="{'router-link-exact-active':$route.name=='reports'}"
        >
          <!--            v-on:click="$store.commit('UpdateReportsViewCurrentPeriod', {name: 'thisWeek'})"-->

          <font-awesome-icon class="icon" :icon="['fas', 'chart-line']"/>
          {{ $t("Rapports") }}
        </router-link>
      </li>

      <!------------------------------------------>

      <li>
        <!-- NOTE : pour cette route j'ai forcé manuellement la class "router-link-exact-active" si le nom de la route est égal à "project-details" -->
        <router-link
            v-bind:to="{ name: 'projects', params:{locale : $route.params.locale, organization: $route.params.organization}}"
            id="appMenuLinkProjects"
            v-bind:class="{'router-link-exact-active':$route.name=='project-details'}"
        >
          <font-awesome-icon class="icon" :icon="['far', 'folder-open']"/>
          {{ $t("Projets") }}
        </router-link>
      </li>

      <!------------------------------------------>

      <li v-if="$auth.hasRole('ROLE_ADMIN')">
        <router-link
            v-bind:to="{ name: 'clients', params:{locale : $route.params.locale, organization: $route.params.organization}}"
            id="appMenuLinkClients">
          <font-awesome-icon class="icon" :icon="['fas', 'user-tie']"/>
          {{ $t("Clients") }}
        </router-link>
      </li>


      <!------------------------------------------>

      <li>
        <router-link v-bind:to="{ name: 'teamUsers'}">
          <font-awesome-icon class="icon" :icon="['fas', 'users']"/>
          {{ $t("Équipe") }}
        </router-link>
      </li>
      <!------------------------------------------>
      <li>

        <router-link
            v-bind:to="{ name: 'tags', params:{locale : $route.params.locale, organization: $route.params.organization, workspace :workspaceSlug}}"
            id="appMenuLinkTags"
        >
          <font-awesome-icon class="icon" :icon="['fas', 'tag']"/>
          {{ $t("Tags") }}
        </router-link>
      </li>

      <!------------------------------------------>

      <li>

        <!-- NOTE : pour la route "user-settings" on force la classe "router-link-exact-active" si le nom de la route est égal à :
        - "workspace-subscription"
        - "workspace-subscription"
        -->
        <router-link
            v-bind:to="{ name: 'user-settings', params:{locale : $route.params.locale, organization: $route.params.organization}}"
            id="appMenuLinkUserSettings"
            v-bind:class="{'router-link-exact-active':
            $route.name=='workspace-subscription'
            || $route.name=='subscription-success'
            || $route.name=='subscription-cancel'
        }"
        >
          <font-awesome-icon class="icon" :icon="['fas', 'cog']"/>
          {{ $t("Réglages") }}
        </router-link>
      </li>

      <!------------------------------------------>

      <!--      <li>-->
      <!--        <router-link v-bind:to="{name:'logout'}" id="appMenuLinkSupport">-->
      <!--          <font-awesome-icon class="icon"  :icon="['far', 'life-ring']" />-->
      <!--          {{ $t("Assistance") }}-->
      <!--        </router-link>-->
      <!--      </li>-->

      <!------------------------------------------>

      <li>
        <router-link v-bind:to="{name:'logout'}" id="appMenuLinkLogout">
          <font-awesome-icon class="icon" :icon="['fas', 'power-off']"/>
          {{ $t("Déconnexion") }}
        </router-link>
      </li>

    </ul>

    <div class="is-desktop2" id="mailtoSupportLink">
      <span>{{ $t('VousAvezBesoinDAide') }} <a href="mailto:support@cronocloud.com">support@cronocloud.com</a></span>
    </div>

  </aside>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
import {mapState} from 'vuex'

export default {
  name: 'AppMenuComp',
  data: function () {
    return {
      workspaceSlug: this.$auth.getActiveWorkspace(), //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290

      // isOpened: true,
    }
  },
  computed: mapState({
    AppMenuCompIsOpened: state => state.AppNavbarComp.menu.isOpened,
    themeToDisplay: state => state.app.themeToDisplay
  }),

  //  methods: {},
  //
  //  created: function () {
  // },

}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
@import "../assets/css/bulmaResponsiveDep.scss";


$menuBgColor: #333839;
.menu {
  background-color: $menuBgColor;
  /*min-height: calc(100vh - ( #{$appNavbarHeight} - .75rem)); // vu sur https://codepen.io/wikiki/pen/OjdNKM  */
  min-height: 100%;
  padding-top: 4rem;

  @include mobile {
    padding-top: 0;
    min-height: auto;
  }


  .menu-list {

    a {
      text-align: left;
      padding: 1.6rem;
      font-family: Lato, sans-serif;
      font-size: 0.85rem;
      text-transform: uppercase;
      border-top: solid 1px lighten($menuBgColor, 5%);
      font-weight: 700;
      transition: background-color;
      transition-duration: 300ms;
      transition-timing-function: ease;

      // gestion de l'item actif via vue-router  @link https://router.vuejs.org/api/#active-class
      &.router-link-exact-active
        /*, &.router-link-active*/
      {
        background: #3f4647;
        color: white;

        .icon {
          color: white;
        }
      }

      @include mobile {
        border-bottom: solid 1px #404647;
      }

      &:hover {
        transition-property: color;
        transition-duration: 400ms;
        transition-timing-function: ease;
        //background-color:red;
      }

      .icon {
        color: $brandPrimary;

        $size: 1.4rem;
        width: $size;
        height: $size;
        vertical-align: text-bottom;

        margin: 0 0.5rem 0 1rem;

      }


    }

    /*.new{*/
    /*  font-size: 0.7rem;*/
    /*  vertical-align: top;*/
    /*  margin-left: 0.8rem;*/
    /*  animation: glow 1s infinite alternate;*/
    /*}*/

    @keyframes glow {
      from {
        color: #666;

      }
      to {
        color: gold;


      }
    }
  }

  #mailtoSupportLink {
    color: #ccc;
    font-size: 0.85rem;
    padding: 1rem 2rem;
    border-top: solid 1px #444;
    margin-top: 20vh;

    a {
      display: inline;
      color: $brandPrimary;
    }
  }

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {
    background-color: $darkBg2 !important;

    .menu-list {
      .icon {
        color: $darkLightBlue
      }
      a {
        &:hover{
          background-color: darken($darkBg2,2%);
        }
      }
    }

  }

}


</style>
